import { ref } from 'vue';

// App.vueの :key に使用するリアクティブな変数
export const appKey = ref(0); 

// キーを更新し、App.vueの再描画を強制する関数
export function forceAppRerender() {
  appKey.value += 1;
  console.log('App Key updated:', appKey.value);
}